import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { List, Toast, InputItem } from 'antd-mobile';
import { createBrowserHistory } from "history";
import './style.less';
import { Button } from 'antd';

const history = createBrowserHistory();
export default class ForgetPSW extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fname: '忘记密码',
      cardcode: this.props.match.params.cardcode,
      publicid: this.props.match.params.publicId,
      wait: 180,
      mobile: '',
      newPsw: '',
      newPsw1: '',
      platform: 6,
      MobileCode: '',
      rowid: '',
      isshow: false,
      HGuid: '',
      sjyz_show: false,
      yz_show: false,
      yz_show2: true,
      m_user: JSON.parse(localStorage.getItem('QUANREN_SSO_MM_USER_CACHE')),
    }
    this.handleChangeMobile = this.handleChangeMobile.bind(this);
    this.handleChangeMobileCode = this.handleChangeMobileCode.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangePassword1 = this.handleChangePassword1.bind(this);

  }
  getTime = () => {
    if (this.state.wait === 0) {
      this.setState({ yz_show2: false });
    } else {
      let wait = this.state.wait;
      wait--;
      this.setState({ wait: wait });
      setTimeout(this.getTime, 1000);
    }
  }
  cancel = () => {
    history.goBack();
  }
  verification = () => {
    if (this.state.MobileCode === '') {
      Toast.info('验证码不能为空！', 1);
      return false;
    }
    if (this.state.newPsw === '') {
      Toast.info('密码不能为空！', 1);
      return false;
    }
    if (this.state.newPsw === '' || this.state.newPsw.length < 6) {
      Toast.info('新密码格式错误！', 1);
      return false;
    }
    if (this.state.newPsw !== this.state.newPsw1) {
      Toast.info('密码输入不一致!', 1);
      return false;
    }

    return true;
  }
  ModifyMobile = () => {
    if (!this.VerificationMobile()) {
      return false;
    }
    if (!this.verification()) {
      return false;
    }
    let parameter2 = { id: this.state.HGuid, code: this.state.MobileCode };
    let parameter ={ PublicId:parseInt(this.state.publicid),Mobile:this.state.mobile,newPassword:this.state.newPsw}
        services.CheckVerifyCode(parameter2, '').then(value => {
          if (value.result && value.status === 0) {                
            services.ForgetUpdatepw(parameter, '正在执行，请稍后').then(data => {
                if (data.status === 0) {
                    Toast.success(data.message, 1, () => {
                      history.push(`/members/integralD/${this.state.publicid}`);
                      history.go();
                      });
                  
                } else {
                    Toast.offline(data.message);
                }
            })
        } else {
            Toast.offline('验证码错误，请输入正确的验证码',1);
        }
        });   
  }
  SendCode = () => {
    if (!this.VerificationMobile()) {
      return false;
    }
    let params = {
      mobile: this.state.mobile
    }
    services.SendVerifyCode(params, '').then(data => {
      if (data.status === 0) {
        Toast.success('发送成功，请在手机上查看验证码', 2);
        this.setState(
          { HGuid: data.result.guid, sjyz_show: true, ishow: true, yz_show: true, yz_show2: true, wait: 180 },
          () => {
            this.getTime();
          }
        );
      } else {
        Toast.offline(data.message);
      }
    });
   

  }
  VerificationMobile() {
    var regex = /^1\d{10}$/;
    if (this.state.mobile === '' || !regex.test(this.state.mobile)) {
      Toast.info('电话号码输入错误，请重新输入！', 1);
      return false;
    }
    return true;
  }
  handleChangeMobile = (e) => {
    this.setState({ mobile: e.replace(/\s/g,"") });
  }
  handleChangePassword = (e) => {
    this.setState({ newPsw: e });
  }
  handleChangePassword1 = (e) => {
    this.setState({ newPsw1: e });
  }
  handleChangeMobileCode = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({ MobileCode: value });
  }

  render() {
    const { sjyz_show, yz_show, yz_show2 } = this.state;
    return <div className="editForm">
      <CommonlyHeadMembers barname="忘记密码" />

      <List renderHeader={() => this.state.fname}>
        <InputItem
        type="phone"
          clear name="Mobile"
          placeholder="手机号码" onChange={this.handleChangeMobile}
          ref={el => this.refMobile = el}
        >手机号码</InputItem>
        <List.Item>
          <span className="name">验&nbsp;&nbsp;&nbsp;证&nbsp;&nbsp;&nbsp;码</span><input className="shortInput" onChange={this.handleChangeMobileCode} name="vCode" type="tel" placeholder="验证码" /><Button className="yz" onClick={this.SendCode} disabled={yz_show}>获取验证码</Button>
        </List.Item>
        {
          sjyz_show === true ?
            <div>
              <div className="sjyz_tip" >
                如果3分钟内没有收到校验短信，您可以重新通过“短信”方式获取验证码，此服务免费。<Button disabled={yz_show2} onClick={this.SendCode}>{this.state.wait === 0 ? '重新获取短信' : '(' + this.state.wait + '秒后)重新获取短信'}</Button></div>

            </div>
            : ''
        }
        {
          sjyz_show === true ?
            <InputItem
            type="password"
              clear name="newPsw"
              placeholder="请输入新密码" onChange={this.handleChangePassword}
              ref={el => this.refnewPsw = el}
            >新密码</InputItem>
            : ''
        }
        {
          sjyz_show === true ?
            <InputItem
            type="password"
              clear name="newPsw1"
              placeholder="请再次输入新密码" onChange={this.handleChangePassword1}
              ref={el => this.refnewPsw = el}
            >确认密码</InputItem>
            : ''
        }
        {
          sjyz_show === true ?
            <div className="butdiv"><Button onClick={this.cancel}>取消</Button><Button className="ok" onClick={this.ModifyMobile}>确定修改</Button></div>
            : ''
        }
      </List>
    </div>;
  }
}